import { StructureBuilder } from "sanity/structure";

export default (S: StructureBuilder) =>
  S.listItem()
    .title("Lead Modals")
    .schemaType("leadModal")
    .child(S.documentTypeList("leadModal"));
